{
  "tasks": {
    "title": "Aufgaben",
    "description": "Aufgaben, die dir eine Kollegin, ein Kollege oder eine App übertragen hat",
    "columns": {
      "title": "Aufgabe",
      "createdBy": "Erstellt von",
      "dueAt": "Fällig am",
      "source": "Bezug"
    },
    "markDone": "Erledigt",
    "openSource": "Öffnen",
    "empty": "Keine offenen Aufgaben",
    "search": "Aufgaben durchsuchen...",
    "completed": "„{{title}}“ erledigt",
    "completeFailed": "Die Aufgabe konnte nicht erledigt werden",
    "review": "Ansehen"
  },
  "myTasks": {
    "title": "Meine Aufgaben",
    "description": "Alles, was gerade auf dein Handeln wartet",
    "openProcessesTitle": "Offene Prozesse",
    "openProcessesDescription": "Prozesse in deiner Verantwortlichkeit, deren Aufnahme du noch nicht begonnen hast",
    "inProgressRecordingsTitle": "Laufende Aufnahme",
    "inProgressRecordingsDescription": "Prozessschritte, die du begonnen hast zu beschreiben, aber noch nicht abgeschlossen hast",
    "assignmentsTitle": "Meine Zuweisungen",
    "assignmentsDescription": "Prozessschritte, die dir zugewiesen wurden und auf deine Bearbeitung warten.",
    "pendingSurveysTitle": "Ausstehende Umfragen",
    "pendingSurveysDescription": "Gib Feedback zu deinen aufgenommenen Prozessschritten",
    "pendingReviewsTitle": "Ausstehende Prüfungen",
    "pendingReviewsDescription": "Genehmige oder lehne Systeme und Funktionen ab, die während der Aufnahme vorgeschlagen wurden",
    "noPendingReviews": "Keine ausstehenden Prüfungen",
    "searchPendingReviews": "Prüfungen durchsuchen...",
    "review": "Prüfen",
    "kind": "Typ",
    "name": "Name",
    "submittedBy": "Eingereicht von",
    "source": "Vorgeschlagen in",
    "submittedAt": "Eingereicht",
    "openSourceRecording": "Aufnahme öffnen",
    "unnamedProcess": "Unbenannter Prozess",
    "process": "Prozess",
    "department": "Abteilung",
    "processOwner": "Prozessverantwortlicher",
    "processStep": "Prozessschritt",
    "previousProcessStep": "Vorheriger Prozessschritt",
    "processStart": "Prozessstart",
    "processStepGeneric": "Prozessschritt",
    "newStep": "Neue Prozessschritt-Zuweisung",
    "unclearResolution": "Unklarer nächster Bearbeiter",
    "decisionStep": "Entscheidungsschritt",
    "dueDate": "Fälligkeitsdatum",
    "startedDate": "Startdatum",
    "assignedBy": "Zugewiesen von",
    "startRecording": "Aufnahme starten",
    "completeSurvey": "Umfrage abschließen",
    "noOpenProcesses": "Keine offenen Prozesse gefunden",
    "noInProgressRecordings": "Keine laufenden Aufzeichnungen gefunden",
    "noAssignments": "Keine ausstehenden Zuweisungen gefunden",
    "noPendingSurveys": "Keine ausstehenden Umfragen gefunden",
    "searchInProgressRecordings": "Aufnahmen durchsuchen...",
    "searchSurveys": "Umfragen durchsuchen...",
    "searchOpenProcesses": "Prozesse durchsuchen...",
    "searchAssignments": "Zuweisungen durchsuchen...",
    "noTasksTitle": "Alle Aufgaben geschafft!",
    "noTasksDescription": "Gerade wartet nichts auf dich. Neue Aufgaben erscheinen automatisch hier.",
    "variantAnswerSaved": "Antwort gespeichert",
    "variantAnswerFailed": "Antwort konnte nicht gespeichert werden",
    "surveySubmitFailed": "Umfrage konnte nicht eingereicht werden"
  },
  "assignmentReview": {
    "previousStep": "Vorheriger Schritt",
    "outputLabel": "Ausgabe:",
    "stepInfoUnavailable": "Schritt-Informationen nicht verfügbar",
    "accept": "Mir zuweisen",
    "deny": "Nicht mir zuweisen",
    "successAcceptedTitle": "Du wurdest erfolgreich zugewiesen!",
    "successAcceptedDesc": "Du kannst jetzt mit der Beschreibung deines Prozessschrittes beginnen.",
    "successRejectedTitle": "Vielen Dank für deine Rückmeldung!",
    "successRejectedDesc": "Der Prozessschritt wird neu zugewiesen.",
    "finish": "Fertig",
    "mergeSectionTitle": "Dieser Schritt existiert möglicherweise bereits in diesem Prozess",
    "mergeSectionDescription": "Anstatt von Grund auf aufzuzeichnen, kannst du diese Zuweisung mit einem bestehenden Schritt zusammenführen.",
    "mergeInto": "Mit diesem Schritt zusammenführen",
    "mergeConfirmTitle": "Zuweisung zusammenführen?",
    "mergeConfirmDescription": "Diese Zuweisung wird mit \"{{stepName}}\" verknüpft, anstatt eine neue Aufzeichnung zu erstellen. Diese Aktion kann nicht rückgängig gemacht werden.",
    "mergeConfirm": "Zusammenführen",
    "mergeCancel": "Abbrechen",
    "mergeError": "Zusammenführung der Zuweisung fehlgeschlagen",
    "unnamedStep": "Unbenannter Schritt",
    "selectMergeCandidate": "Schritt zum Zusammenführen auswählen…",
    "searchMergeCandidates": "Schritte suchen…",
    "noMergeCandidates": "Keine passenden Schritte gefunden.",
    "systemAssigneeHintTitle": "Dieser Schritt wird von einem System ausgeführt",
    "systemAssigneeHintDescription": "Du bist für dieses System als Systemverantwortlicher hinterlegt. Beschreibe, was das System tut – nicht, was du selbst tust.",
    "externalContactAssigneeHintTitle": "Dieser Schritt wird von einem externen Kontakt ausgeführt",
    "externalContactAssigneeHintDescription": "Du nimmst diesen Schritt stellvertretend auf. Beschreibe, was der externe Kontakt tut — nicht, was du selbst tust."
  },
  "reassignContext": {
    "title": "Nächsten Bearbeiter zuweisen",
    "descriptionPending": "Wähle eine neue zuständige Person – oder markiere den Schritt als unklar, wenn noch nicht bekannt ist, wer ihn übernimmt.",
    "descriptionPendingUnclear": "Löse die unklare Zuweisung: Wähle, wer den nächsten Schritt übernimmt.",
    "descriptionRecording": "Wähle eine neue zuständige Person – oder markiere den Schritt als unklar, wenn noch nicht bekannt ist, wer ihn übernimmt.",
    "unclearAlertTitle": "Zuweisung als unklar markiert",
    "unclearAlertDescription": "Diese Zuweisung wurde dir als Prozessverantwortlicher zugewiesen, weil bei der Aufnahme nicht festgelegt wurde, wer den nächsten Schritt übernimmt. Prüfe die Schrittdetails und weise einen nächsten Bearbeiter zu.",
    "markedUnclearBy": "Als unklar markiert von",
    "stepDetails": "Schrittdetails",
    "currentStep": "Schritt, der neu zugewiesen wird",
    "assignToHeading": "Zuweisen an",
    "chooseAssignee": "Person, Funktion oder System auswählen",
    "markedUnclear": "Als unklar markiert",
    "confirm": "Weiter"
  },
  "celebration": {
    "banner": {
      "title": "Danke für deinen Einsatz!",
      "description_one": "Du hast gerade 1 Aufgabe abgeschlossen.",
      "description_other": "Du hast gerade {{count}} Aufgaben abgeschlossen.",
      "doneCount": "{{count}} erledigt",
      "openCount": "{{count}} offen"
    },
    "recordingStarted": {
      "title": "Aufnahme gestartet!",
      "description": "„{{process}}“ läuft: Die ersten Beteiligten sind eingeladen und beschreiben jetzt ihre Schritte."
    },
    "survey": {
      "title": "Danke für dein Feedback!",
      "remaining_one": "Noch 1 Umfrage offen – sie dauert etwa eine Minute.",
      "remaining_other": "Noch {{count}} Umfragen offen – jede dauert etwa eine Minute.",
      "allDone": "Alle Umfragen erledigt. Damit weiß dein Team, wie die Arbeit wirklich läuft.",
      "nextSurvey": "Nächste Umfrage"
    },
    "step": {
      "title": "Geschafft!",
      "description": "Dein Schritt ist jetzt Teil von „{{process}}“. Danke, dass du dein Wissen teilst!",
      "startSurvey": "Kurze Umfrage starten (ca. 1 Min.)"
    },
    "toTasks": "Zu meinen Aufgaben",
    "later": "Später"
  },
  "approvals": {
    "status": {
      "approved": "Freigegeben",
      "executed": "Ausgeführt",
      "rejected": "Zurückgewiesen",
      "overridden": "Ohne Freigabe fortgefahren",
      "withdrawn": "Zurückgezogen",
      "pending": "Offen"
    },
    "card": {
      "progress": "{{count}} von {{total}} freigegeben",
      "requestedBy": "Angefordert von {{name}} am {{date}}",
      "due": "fällig {{date}}",
      "reviewers": "Prüfer",
      "reviewersNeeded_one": "{{count}} von {{total}} muss freigeben",
      "reviewersNeeded_other": "{{count}} von {{total}} müssen freigeben",
      "verdict": {
        "open": "noch offen",
        "approved": "hat freigegeben ({{date}})",
        "rejected": "hat zurückgewiesen ({{date}})"
      },
      "overriddenBy": "{{name}} hat ohne Freigabe fortgefahren ({{date}})",
      "rejectReason": "Grund der Zurückweisung",
      "rejectReasonPlaceholder": "Warum? Die anfordernde Person liest den Grund.",
      "approve": "Freigeben",
      "reject": "Zurückweisen",
      "confirmReject": "Mit Grund zurückweisen",
      "withdraw": "Zurückziehen",
      "openRecord": "Öffnen",
      "override": "Ohne Freigabe fortfahren"
    },
    "override": {
      "title": "Ohne Freigabe fortfahren?",
      "warning": "Das Vier-Augen-Prinzip wird umgangen. Die Prüfer werden informiert, der Vorgang wird als übersprungen protokolliert.",
      "confirm": "Ohne Freigabe fortfahren",
      "reason": "Grund",
      "reasonPlaceholder": "Warum kann nicht gewartet werden?"
    },
    "recipients": {
      "intro_one": "Diese Person erhält eine Aufgabe:",
      "intro_other": "Diese {{count}} Personen erhalten eine Aufgabe:",
      "due": "Fällig am {{date}}.",
      "required": "{{count}} von {{total}} müssen freigeben."
    },
    "dialogTitle": "Freigabe",
    "actionFailed": "Die Aktion ist fehlgeschlagen",
    "toast": {
      "approved": "Freigegeben",
      "rejected": "Zurückgewiesen",
      "overridden": "Ohne Freigabe fortgefahren",
      "withdrawn": "Zurückgezogen"
    },
    "title": "Freigaben",
    "descriptionAll": "Alle Freigaben des Arbeitsbereichs",
    "descriptionMine": "Freigaben, die du angefordert hast oder prüfst",
    "empty": "Keine Freigaben",
    "search": "Freigaben durchsuchen",
    "columns": {
      "label": "Was",
      "status": "Status",
      "requestedBy": "Angefordert von",
      "reviewers": "Prüfer",
      "requestedAt": "Angefordert am"
    }
  }
}
